import request from '@/utils/request'

export default {
    queryCourseList: function (form) {
        return request({
            url: 'course/list',
            method: 'post',
            data: form
        });
    },
    queryCourseDetail: function (courseId) {
        return request({
            url: 'course/detail',
            method: 'post',
            params: {courseId:courseId}
        });
    },
}